import type { FeatureFlagDto } from '@portals/shared/portal/FeatureFlagDto';
import { createContext } from 'react';

export const DEFAULT_FEATURE_FLAGS: FeatureFlagDto = {
  ALLOW_API_OWNER_APP_CHANGE: false,
  ENABLE_SCOPE_OVERVIEW: false,
  ENABLE_CLIENT_IMPORT: false,
  ENABLE_READ_ONLY_MODE: false,
  ENABLE_TEAMS: false,
  ENABLE_DOC_BETA_MODE: false,
  ENABLE_COMMON_REPO_API: false,
  ENABLE_CUSTOM_PAGES_FOR_TEAMS: false,
  ENABLE_NEW_CONSUMER_APP_CREATION: false,
  ENABLE_ENV_COLOR_INDICATOR: false,
  ENABLE_SEMANTIC_SEARCH: false,
  ENABLE_MCP_PAGES: false,
};

interface FeatureFlagContextValue {
  featureFlags: FeatureFlagDto;
  isLoading: boolean;
}

const FeatureFlagContext = createContext<FeatureFlagContextValue>({
  featureFlags: DEFAULT_FEATURE_FLAGS,
  isLoading: true,
});

export default FeatureFlagContext;
